export class ObjectUtil {
  public static get(obj: any, key: string) {
    try {
      return (key || '').split('.').reduce((result, k) => {
        return result[k]
      }, obj)
    } catch (e) {
      return
    }
  }

  public static deepClone<T>(obj: T): T {
    return JSON.parse(JSON.stringify(obj))
  }
}
